import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import {
  hasUserGroup,
  isPageTypeCampaignBrief,
} from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import { enablePermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const executionManagerGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkExecutionManagerPolicy -->");
  if (hasUserGroup(context, UserGroup.EXECUTIVE_MANAGERS)) {
    // console.log("checkExecutionManagerPolicy --> TRUE");

    if (isPageTypeCampaignBrief(context)) {
      enablePermissions(permissions, "manageExecBriefs");
    }
  }

  if (next) {
    return next(context, permissions);
  }
};
